import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Color from '../../styles/common/Color';
import { ReactComponent as Alert } from '../../images/common/alert.svg';

const HeaderNotice = styled.div`
  width: 100%;
  min-height: 48px;
  border: 1px solid;
  margin-bottom: 10px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  opacity: 1;
`;

const DangerHeaderNotice = styled(HeaderNotice)`
  background: ${Color.pink};
  color: ${Color.dangerDark};
  & svg {
    width: 22px;
    height: 19px;
    margin-right: 5px;
    fill: ${Color.danger};
  }
`;

const createElement = msg => (
  <>
    <Alert />
    <label>{msg}</label>
  </>
);

const DangerNotice = ({ msg }) => (
  <DangerHeaderNotice id="headerNotice">
    {createElement(msg)}
  </DangerHeaderNotice>
);

DangerNotice.propTypes = {
  msg: PropTypes.string.isRequired,
};

export default DangerNotice;
